import {
  Component,
  Inject,
  Input,
  OnInit,
  ChangeDetectionStrategy
} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppService } from 'src/app/app.service';
import { ApiRequestService } from 'src/app/shared/api-request.service';
import { UtilsService } from 'src/app/shared/utils.service';
import { RBACService } from 'src/app/shared/rbac.service';
import { SsspTabsComponent } from './sssp-tabs.component';

@Component({
  selector: 'app-sssp-tabs-dialog',
  templateUrl: './sssp-tabs.component.html',
  styleUrls: ['./sssp-tabs.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SsspTabsDialogComponent extends SsspTabsComponent
  implements OnInit {
  @Input('sssp_hash') sssp_hash: string;

  constructor(
    public app: AppService,
    public api: ApiRequestService,
    public utils: UtilsService,
    public rbac: RBACService,
    public dialogRef: MatDialogRef<SsspTabsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private dialogData: any
  ) {
    super(app, api, utils, rbac);
  }

  ngOnInit() {
    // If the dialog data is available, use it instead.
    if (this.dialogData['sssp_hash']) {
      this.sssp_hash = this.dialogData['sssp_hash'];
    }

    // Called from super class.
    this.getSSSP().then(() => {
      if (!this.sssp.id) {
        // The request failed to return the Safety Plan data.
        // Close the dialog.
        this.dialogRef.close();
      }
    });
  }
}
